// @flow 
import * as React from 'react';
import Lottie from 'react-lottie';
import success from './lotties/59865-confirmation-tick.json';

const LottieAnimation = ({
    height = 100,
    width = 100,
    loop = false,
    autoplay = true,
    name }) => {

    let animationData = '';

    switch (name) {
        case 'success':
            animationData = success;
            break;
    }

    const defaultOptions = {
        loop,
        autoplay,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <div>
            <Lottie
                options={defaultOptions}
                height={height}
                width={width}
            />
        </div>
    );
};

export default LottieAnimation;